declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest, SectionData, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FormOrganizer, SaveOTSectionDataRequest, TreatmentCyclesByActorCodeController, TreatmentCyclesByActorCodeRequest, TreatmentCycleStatusController, TreatmentCycleStatusRequest, FollicularScanDetailController, FollicularScanDetailRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, DSAActivityByCycleCodeController, DSAActivityByCycleCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, SaveFollicularScanDetailRequest, SaveFollicularScanOvaryDetailRequest, SaveIvfCycleTestDataRequest, SaveIvfCycleMedicineDataRequest, SaveTestMedCycleActivitiesRequest, IvfTreatmentPlanController, IvfTreatmentPlanRequest, SaveFollicularPickupsDetailV2Request, FollicularPickUpsByCodeController, FollicularPickUpsByCodeRequest, UpdateIvfCycleByActivityRequest, TreatmentCycleActiityMasterController, IvfCycleActivityMasterRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, OocyteMaturityByCycleController, OocyteMaturityByCycleRequest, SaveSingleWellFollicleRequest, SaveOocyteMaturityInfoRequest, SaveOocyteMorphologyInfoRequest, SaveIvfOocyteEmbryoStorageRequest, SaveCycleStatusRequest, OocyteMorphologyByCycleController, OocyteMorphologyByCycleRequest, OqaDetails, OocyteAbnormalitiesDetails, SpermSourceDetailsController, SpermSourceDetailsRequest, IvfSpermStoreByCodeController, IvfSpermStoreByCodeRequest, SaveSpermDetailsRequest, SaveSemenDataRequest, SaveIvfSpermStoreRequest, SaveSingleWellInseminationInfoRequest, SaveIvfCycleInseminationLogRequest, SaveIvfCycleInseminationInfoRequest, CompleteIvfCycleInseminationRequest, SingleWellInseminationByCycleController, SingleWellInseminationByCycleRequest, IvfCycleInseminationLogByCycleWithDOCController, IvfCycleInseminationLogByCycleWithDOCRequest, IvfCycleInseminationByCycleController, IvfCycleInseminationByCycleRequest, SingleWellCultureByCycleCodeController, SingleWellCultureByCycleCodeRequest, SaveSingleEmbryoGradeInfoRequest, SaveEmbryoStoreInfoRequest, ReadyForEmbroTransferRequest, ConvertEmbryoGradingToWellCultureRequest, EmbryosFromStoreController, EmbryosFromStoreRequest, IvfCycleMembersListController, IvfCycleMembersListRequest, IvfEmbryoTransferAttemptByCycleCodeController, IvfEmbryoTransferAttemptByCycleCodeRequest, IvfCycleEmbryoTransferredController, IvfCycleEmbryoTransferredRequest, SaveIvfEmbryoTransferAttemptRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe, OocyteAbPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbEditOvaryModal } from '../ivfworkbench/editovary.modal';
import { NgbAddScanTestModal } from '../ivfworkbench/addscantest.modal';
import { NgbAddScanMedicineModal } from '../ivfworkbench/addscanmedicine.modal';
import { NgbEditScanMedicineModal } from '../ivfworkbench/editscanmedicine.modal';
import { NgbEditScanTestModal } from '../ivfworkbench/editscantest.modal';
import { NgbEventAddModal } from './eventadd.modal';
import { PrintService } from '../../../../services/print.service';
import { NgbSearchProviderModal } from '../ivfworkbench/searchprovider.modal';
import { NgbAddOqaModal } from '../ivfworkbench/addoqa.modal';
import { NgbEditOqaModal } from '../ivfworkbench/editoqa.modal';
import { NgbAddAbnormalOqaModal } from '../ivfworkbench/addabnormaloqa.modal';
import { NgbEditAbnormalOqaModal } from '../ivfworkbench/editabnormaloqa.modal';
import { NgbSearchDonarModal } from './searchdonar.modal';
import { NgbAddInseminationLogModal } from '../ivfworkbench/addinseminationlog.modal';
import { NgbEditInsemiModal } from '../ivfworkbench/editinsemi.modal';
import { NgbEditInseminationLogModal } from '../ivfworkbench/editinseminationlog.modal';
import { NgbEditGradingModal } from '../ivfworkbench/editgrading.modal';
import { NgbEditGradingDayModal } from '../ivfworkbench/editgradingday.modal';
import { NgbEditGradingetModal } from '../ivfworkbench/editgradinget.modal';
import { NgbEditGradingFetDetailModal } from '../ivfworkbench/editgradingfetdetail.modal';

@Component({
    selector: 'tretedit',
    templateUrl: './tretedit.modal.html',
    styleUrls: ['./tretedit.modal.scss']
})

export class NgbTrEtEditModal implements OnInit {
    @ViewChild('f') IdentitiesForm: NgForm;
    @Input() ActorCode:number;
    @Input() TemplateName: string;
    @Input() CycleCode: number;
    @Input() FollicularGrowthCode: number;
    @Input() ActivityCode: number;
    //@Input() PatientCode: number;
    @Input() FormattedCode: string;
    @Input() IsShowDetail: boolean = false;
    @Input() SectionSequenceNO: number;
    @Input() SectionTypeCode: number;
    @Input() Date: Date;
    @Input() Sign1: string;
    @Input() Sign2: string;
    @Input() TitleName: string;
    @Input() DOC: number;
    @Input() GradingModel: string;
    @Input() sectionData: SectionData;
    @Input() PatientReportCode: any;
    OvulationTriggerDate: NgbDateStruct;
    public ActivityDate: NgbDateStruct;
    public TransferDateNew: Date;
    TransferEndDate: NgbDateStruct;
    public displayPatientdata: boolean = true;
    public displayscansdata: boolean = false;
    @Input() Eggsourcetype: string;
    public EggSourceType: string;
    ExpiryDate: NgbDateStruct;
    ExpiryDate2: NgbDateStruct;
    OvumPickupdate: NgbDateStruct;
    OvumPlannedPickupDate: NgbDateStruct;
    DateofSampleCollection: NgbDateStruct;
    //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
    @Input() ServiceCode: number;
    searchTitle: string;
    ScanDate: NgbDateStruct;
    NextScanDate: NgbDateStruct;
    public EggSourceActorCode: number;
    public ReceipientActorCode: number;
    public OvulationtriggerDate: Date;
    //private isvisibleendo: boolean = true;
    public ApiResData: ApiResponseModel;
   // public data: string;
    public isRequesting: boolean = false;
    public ShowService: boolean = true;
    private isvisible: boolean = true;
    public ActivityCodeNew: number;
    private isvisibleendo: boolean = true;
    public ProvidedName: string;
    public Dateofinsemination: Date;
    public ActivityCodenew: number;
    public ProvidedCode: number;
    public Day: number;
    public month: number;
    public Year: number;
    public length: number;
    public Displaynew: boolean = false;
    public Displayold: boolean = true;
    //public IsSelected: boolean;
    ExtractionDate: NgbDateStruct;
    CurrentSaveIvfCycleTestDataRequest: SaveIvfCycleTestDataRequest;
    CurrentSaveIvfCycleMedicineDataRequest: SaveIvfCycleMedicineDataRequest;
    //
    CurrentSaveCycleStatusRequest: SaveCycleStatusRequest;
    CurrentSaveIvfEmbryoTransferAttemptRequest: SaveIvfEmbryoTransferAttemptRequest;
    CurrentTreatmentCyclesByActorCodeController: TreatmentCyclesByActorCodeController[];
    SelectedpatientDetails: TreatmentCyclesByActorCodeController;

    CurrentTreatmentCyclesByActorCodeRequest: TreatmentCyclesByActorCodeRequest;
    LoadPatients() {
       // alert("patientsdetails");
        this.CurrentTreatmentCyclesByActorCodeRequest = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ActorCode = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController();
    }

    GetTreatmentCyclesByActorCodeController() {
        this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController = this.ApiResData.Result;
                    this.SelectedpatientDetails = this.CurrentTreatmentCyclesByActorCodeController[0];
                    //this.LMPDate = this.SelectedTreatmentCycle.LMP;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    this.stopRefreshing();
                   /// this.LoadDSAData();
                    //this.LoadPlan();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
  
  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
      private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe, public printService: PrintService,
      private router: Router, private route: ActivatedRoute, private hcpservice: HCPService, private modalService: NgbModal,
      private tosterservice: NGXToastrService, private spinner: NgxSpinnerService, private parserFormatter: NgbDateParserFormatter, private filter2: OocyteAbPipe,) { }
  ngOnInit() {
   
    this.ShowService = false;
      this.CurrentSaveIvfCycleTestDataRequest = new SaveIvfCycleTestDataRequest();
      this.CurrentSaveIvfCycleTestDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveIvfCycleMedicineDataRequest = new SaveIvfCycleMedicineDataRequest();
      this.CurrentSaveIvfCycleMedicineDataRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveIvfEmbryoTransferAttemptRequest = new SaveIvfEmbryoTransferAttemptRequest();
      this.CurrentSaveIvfEmbryoTransferAttemptRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.CurrentSaveCycleStatusRequest = new SaveCycleStatusRequest();
      this.CurrentSaveCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.LoadPatients();
     
      this.Loadmembers();
      this.LoadCycles();
      this.LoadEmbryoTransfer();
      this.LoadSingle();
      this.LoadPatients2();
      //this.LoadScansData();
      //this.LoadOvaryData();
      
      //this.LoadTestData();
      //this.LoadMedicineData();

  }



    CurrentIvfCycleMembersListController: IvfCycleMembersListController[];
    Memberlist: IvfCycleMembersListController[];
    ReceipentMember: IvfCycleMembersListController[];
    CurrentIvfCycleMembersListRequest: IvfCycleMembersListRequest;
    Loadmembers() {
        this.CurrentIvfCycleMembersListRequest = new IvfCycleMembersListRequest();
        this.CurrentIvfCycleMembersListRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfCycleMembersListRequest.ConditionalOperator = 10;
        this.CurrentIvfCycleMembersListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleMembersListController();
    }
    GetIvfCycleMembersListController() {
        //this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

        this.actorservice.GetIvfCycleMembersListController(this.CurrentIvfCycleMembersListRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentIvfCycleMembersListController = this.ApiResData.Result;
                    // this.Memberlist = this.ApiResData.Result;
                    var list = this.ApiResData.Result;
                    list = list.filter(
                        function (a) {
                            return a.MemberType == "Recepient" && a.OwnerName != a.MemberDisplayName
                        });
                    if (list.length > 0) {
                        this.ReceipentMember = list[0];
                    }

                    //this.Memberlist = list;
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentIvfEmbryoTransferAttemptByCycleCodeController: IvfEmbryoTransferAttemptByCycleCodeController[];
    EmbryoTransFerEndInfo: IvfEmbryoTransferAttemptByCycleCodeController;
    CurrentIvfEmbryoTransferAttemptByCycleCodeRequest: IvfEmbryoTransferAttemptByCycleCodeRequest;
    LoadEmbryoTransfer() {
        this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest = new IvfEmbryoTransferAttemptByCycleCodeRequest();
        this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.ConditionalOperator = 1;
        this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfEmbryoTransferAttemptByCycleCodeController();
    }
    GetIvfEmbryoTransferAttemptByCycleCodeController() {
        //this.StartRefreshing();


        this.actorservice.GetIvfEmbryoTransferAttemptByCycleCodeController(this.CurrentIvfEmbryoTransferAttemptByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentIvfEmbryoTransferAttemptByCycleCodeController = this.ApiResData.Result;
                    this.EmbryoTransFerEndInfo = this.CurrentIvfEmbryoTransferAttemptByCycleCodeController[0];
                    this.TransferDateNew = this.EmbryoTransFerEndInfo.TransferDate;
                    if (this.EmbryoTransFerEndInfo.TransferEndDate != null) {
                        var SValidFrom = new Date(this.EmbryoTransFerEndInfo.TransferEndDate);
                        if (SValidFrom.getFullYear() > 1900) {
                            console.log('this.UpdateDate >1990');
                            this.TransferEndDate = {

                                year: SValidFrom.getFullYear(),
                                month: SValidFrom.getMonth() + 1,
                                day: SValidFrom.getDate()
                            }
                        }
                    }
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();
                   
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentSingleWellCultureByCycleCodeController: SingleWellCultureByCycleCodeController[];
    CurrentSingleWellCultureByCycleCodeRequest: SingleWellCultureByCycleCodeRequest;
    LoadSingle() {

        this.CurrentSingleWellCultureByCycleCodeRequest = new SingleWellCultureByCycleCodeRequest();
        this.CurrentSingleWellCultureByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentSingleWellCultureByCycleCodeRequest.ConditionalOperator = 10;
        this.CurrentSingleWellCultureByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetSingleWellCultureByCycleCodeController()
    }
    GetSingleWellCultureByCycleCodeController() {
        // this.StartRefreshing();


        this.actorservice.GetSingleWellCultureByCycleCodeController(this.CurrentSingleWellCultureByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentSingleWellCultureByCycleCodeController = this.ApiResData.Result;

                    var list = this.CurrentSingleWellCultureByCycleCodeController.filter(
                        function (a) {
                            return a.IsTransferrable == true
                        });

                    this.CurrentSingleWellCultureByCycleCodeController = list;

                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();
                    //this.LoadActorCode();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentTreatmentCyclesByActorCodeController2: TreatmentCyclesByActorCodeController[];
    ActorDetails: TreatmentCyclesByActorCodeController;
    CurrentTreatmentCyclesByActorCodeRequest2: TreatmentCyclesByActorCodeRequest;
    LoadPatients2() {
        this.CurrentTreatmentCyclesByActorCodeRequest2 = new TreatmentCyclesByActorCodeRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCyclesByActorCodeRequest2.Branch = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest2.ActorCode = 0;
        this.CurrentTreatmentCyclesByActorCodeRequest2.ConditionalOperator = 10;
        this.CurrentTreatmentCyclesByActorCodeRequest2.FromDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest2.ToDate = new Date();
        this.CurrentTreatmentCyclesByActorCodeRequest2.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCyclesByActorCodeRequest2.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCyclesByActorCodeController2();
    }

    GetTreatmentCyclesByActorCodeController2() {
        // this.StartRefreshing();


        this.actorservice.GetTreatmentCyclesByActorCodeController(this.CurrentTreatmentCyclesByActorCodeRequest2)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCyclesByActorCodeController2 = this.ApiResData.Result;
                    this.ActorDetails = this.CurrentTreatmentCyclesByActorCodeController2[0];
                    this.ReceipientActorCode = this.ActorDetails.RecepientActorCode;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    // this.stopRefreshing();
                    this.LoadMasterReq();
                    this.LoadDSAData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    ActorCodeLoad() {
        //alert("ActorCode");
        var SelectedActorCode = this.ReceipientActorCode;
        return SelectedActorCode;
    }
    GetActorCode(EggSourceType: string): number {
        // alert("new");
        if (EggSourceType == 'Donor') {
            var DonorActorCode = this.ActorDetails.RecepientActorCode;
            return DonorActorCode;
        }
        else if (EggSourceType == 'Self') {
            var OwnerActorCode = this.ActorDetails.RecepientActorCode;
            return OwnerActorCode;
        }

    }

    CurrentIvfTreatmentPlanController: IvfTreatmentPlanController;
    PlanDetails: IvfTreatmentPlanController;
    CurrentIvfTreatmentPlanRequest: IvfTreatmentPlanRequest;
    LoadActorCode() {
        this.CurrentIvfTreatmentPlanRequest = new IvfTreatmentPlanRequest();
        this.CurrentIvfTreatmentPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.CurrentIvfTreatmentPlanRequest.CycleCode = this.CycleCode;
        this.CurrentIvfTreatmentPlanRequest.ConditionalOperator = 10;
        this.CurrentIvfTreatmentPlanRequest.ActorCode = 0;


        this.GetIvfTreatmentPlanController();
    }

    GetIvfTreatmentPlanController() {
        //this.StartRefreshing();
        //this.spinner.show();

        this.actorservice.GetIvfTreatmentPlanController(this.CurrentIvfTreatmentPlanRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    this.CurrentIvfTreatmentPlanController = this.ApiResData.Result;
                    this.PlanDetails = this.CurrentIvfTreatmentPlanController[0];
                    
                    //this.LoadActorCodedetails();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    
    CurrentTreatmentCycleStatusController: TreatmentCycleStatusController[];
    EmbryoTransferData: TreatmentCycleStatusController[];
    EmbryoTransferData2: TreatmentCycleStatusController;
    CurrentTreatmentCycleStatusRequest: TreatmentCycleStatusRequest;
    LoadCycles() {
        this.CurrentTreatmentCycleStatusRequest = new TreatmentCycleStatusRequest();
        //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
        this.CurrentTreatmentCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;

        //this.CurrentCycleOocyteQualityBetweenDateRequest.CycleCode = this.CycleCode;
        //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
        //this.CurrentTreatmentCyclesRequest.From = 0;
        //this.CurrentTreatmentCyclesRequest.Status = "";
        this.CurrentTreatmentCycleStatusRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
        this.GetTreatmentCycleStatusController();
    }

    GetTreatmentCycleStatusController() {
        // this.StartRefreshing();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date();
        //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();
        //this.spinner.show();
        this.actorservice.GetTreatmentCycleStatusController(this.CurrentTreatmentCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentTreatmentCycleStatusController = this.ApiResData.Result;
                    this.EmbryoTransferData = this.ApiResData.Result;
                    var embryotransferlist = this.EmbryoTransferData.filter(
                        function (g) {
                            return g.PhaseActivity == "Embryo Transfer";
                        });
                    this.EmbryoTransferData = embryotransferlist;
                    this.EmbryoTransferData2 = this.EmbryoTransferData[0];
                    //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
                    //this.stopRefreshing();
                    this.LoadDSAData();
                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    
    CurrentDSAActivityByCycleCodeController: DSAActivityByCycleCodeController[];
    DSADetails: DSAActivityByCycleCodeController;
    CurrentDSAActivityByCycleCodeRequest: DSAActivityByCycleCodeRequest;

    LoadDSAData() {
       //alert("ScansData")
        this.CurrentDSAActivityByCycleCodeRequest = new DSAActivityByCycleCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentDSAActivityByCycleCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetDSAActivityByCycleCodeController();
    }

    GetDSAActivityByCycleCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentDSAActivityByCycleCodeRequest.TreatmentCycle = this.CycleCode;
        this.CurrentDSAActivityByCycleCodeRequest.ConditionalOperator = 10;
        //this.EggSourceType = this.SelectedpatientDetails.EggSourceType;
        this.CurrentDSAActivityByCycleCodeRequest.ActorCode = this.ActorCode;//this.GetActorCode(this.Eggsourcetype);
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetDSAActivityByCycleCodeController(this.CurrentDSAActivityByCycleCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentDSAActivityByCycleCodeController = this.ApiResData.Result;
                    this.DSADetails = this.GetCycleActivity2(this.GetActorCode(this.SelectedpatientDetails.EggSourceType), this.SelectedpatientDetails.ProtocolStartDate)[0];
                    //alert(this.DSADetails);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(ActorCode, Date)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(ActorCode, Date)[0].STIMULATION;

                    //  this.GetDsADetails(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate);
                    //var list = this.CurrentDSAActivityByCycleCodeController.filter(


                    //    function (a) {
                    //        var Date = this.FollicularScanEndInfo.ScanDate;
                    //        var ActorCode = this.SelectedpatientDetails.ActorID;
                    //        return a.ActivityDate == Date && a.ActorCode == ActorCode
                    //    });

                    //this.CurrentDSAActivityByCycleCodeController = list;
                    //alert(this.CurrentDSAActivityByCycleCodeController[0].DOC);
                    //this.Doc1 = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].DOC;
                    //this.Antag = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].ANTAG;
                    //this.Stimulation = this.GetCycleActivity(this.SelectedpatientDetails.ActorID, this.FollicularScanEndInfo.ScanDate)[0].STIMULATION;
                    //alert(this.Doc1);
                    //alert(this.Antag);
                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    //    GetDsADetails(ActorCode: number, Date: Date) {


    //}
    GetCycleActivity2(ReceipientActorCode: number, TransferDateNew: Date): DSAActivityByCycleCodeController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentDSAActivityByCycleCodeController.filter(
            function (v, i, d) {

                return v.ActorCode == ReceipientActorCode && v.ActivityDate == TransferDateNew;
            }
        )

    }
    GetActorCode2(EggSourceType: string): number {
        // alert("new");
        if (EggSourceType == 'Donor') {
            var DonorActorCode = this.SelectedpatientDetails.EggActorCode;
            return DonorActorCode;
        }
        else if (EggSourceType == 'Self') {
            var OwnerActorCode = this.SelectedpatientDetails.EggActorCode;
            return OwnerActorCode;
        }
    }
    CurrentTreatmentCycleActiityMasterController: TreatmentCycleActiityMasterController[];
    ActivityCodeInfo: TreatmentCycleActiityMasterController;
    CurrentIvfCycleActivityMasterRequest: IvfCycleActivityMasterRequest;

    LoadMasterReq() {
       // alert("ScansData")
        this.CurrentIvfCycleActivityMasterRequest = new IvfCycleActivityMasterRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleActivityMasterRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetTreatmentCycleActiityMasterController();
    }

    GetTreatmentCycleActiityMasterController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.SelectedpatientDetails.TreatmentCycleCode;
        //this.CycleCode = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
        this.CurrentIvfCycleActivityMasterRequest.TreatmentCycle = this.CycleCode;
        this.CurrentIvfCycleActivityMasterRequest.ConditionalOperator = 10;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        //this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //alert(this.FormattedCode);
        this.actorservice.GetTreatmentCycleActiityMasterController(this.CurrentIvfCycleActivityMasterRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentTreatmentCycleActiityMasterController = this.ApiResData.Result;
                    
                    this.LoadTestData();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    //this.GetCycleActivity(this.ActorCode, this.ScanDate);

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    GetCycleActivity(ReceipientActorCode: number, TransferDateNew: Date): TreatmentCycleActiityMasterController[] {
        //alert(ReceipientActorCode);
        //alert(TransferDateNew);
        return this.CurrentTreatmentCycleActiityMasterController.filter(
            function (v, i, d) {

                return v.ActorID == ReceipientActorCode && v.DocDate == TransferDateNew;
            }
        )

    }
    CurrentIvfCycleTestByCodeController: IvfCycleTestByCodeController[];
    CurrentIvfCycleTestByCodeRequest: IvfCycleTestByCodeRequest;

    LoadTestData() {
        //alert("ScansData")
        this.CurrentIvfCycleTestByCodeRequest = new IvfCycleTestByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleTestByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleTestByCodeController();
    }

    GetIvfCycleTestByCodeController() {
        //this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleTestByCodeRequest.CycleCode = this.CycleCode;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentIvfCycleTestByCodeRequest.ActorCode = 0;
        this.CurrentIvfCycleTestByCodeRequest.ConditionalOperator = 20;
        this.LoadEmbryoTransfer();
        var TransferDate = this.EmbryoTransFerEndInfo.TransferDate;
        var ReceipientActorCode = this.ActorDetails.RecepientActorCode;
        this.CurrentIvfCycleTestByCodeRequest.ActivityCode = this.GetCycleActivity(ReceipientActorCode, TransferDate)[0].CycleActivityCode;
        // alert(this.CurrentIvfCycleTestByCodeRequest.ActivityCode);
        this.ActivityCodenew = this.CurrentIvfCycleTestByCodeRequest.ActivityCode;
        this.actorservice.GetIvfCycleTestByCodeController(this.CurrentIvfCycleTestByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleTestByCodeController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();
                    this.LoadMedicineData();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }
    CurrentIvfCycleMedicineByCodeController: IvfCycleMedicineByCodeController[];
    CurrentIvfCycleMedicineByCodeRequest: IvfCycleMedicineByCodeRequest;

    LoadMedicineData() {
        //alert("ScansData")
        this.CurrentIvfCycleMedicineByCodeRequest = new IvfCycleMedicineByCodeRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleMedicineByCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleMedicineByCodeController();
    }

    GetIvfCycleMedicineByCodeController() {
        // this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleMedicineByCodeRequest.CycleCode = this.CycleCode;
        this.CurrentIvfCycleMedicineByCodeRequest.ConditionalOperator = 20;
        this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        this.LoadEmbryoTransfer();
        var TransferDate = this.EmbryoTransFerEndInfo.TransferDate;
        var ReceipientActorCode = this.ActorDetails.RecepientActorCode;
        this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, TransferDate)[0].CycleActivityCode;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleMedicineByCodeController(this.CurrentIvfCycleMedicineByCodeRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleMedicineByCodeController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }

    CurrentIvfCycleEmbryoTransferredController: IvfCycleEmbryoTransferredController[];
    CurrentIvfCycleEmbryoTransferredRequest: IvfCycleEmbryoTransferredRequest;

    LoadDropletEmbryoData() {
        //alert("ScansData")
        this.CurrentIvfCycleEmbryoTransferredRequest = new IvfCycleEmbryoTransferredRequest();
        //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
        //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
        //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
        this.CurrentIvfCycleEmbryoTransferredRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
        this.GetIvfCycleEmbryoTransferredController();
    }

    GetIvfCycleEmbryoTransferredController() {
        // this.StartRefreshing();

        //this.CurrentIvfCycleTestByCodeRequest.ScanCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.CurrentIvfCycleEmbryoTransferredRequest.CycleCode = this.CycleCode;
        this.CurrentIvfCycleEmbryoTransferredRequest.ConditionalOperator = 10;
        // this.CurrentIvfCycleMedicineByCodeRequest.ActorCode = 0;
        //this.CurrentIvfCycleTestByCodeRequest.PatientCode = this.SelectedpatientDetails.PatientCode;
        // this.CurrentIvfCycleMedicineByCodeRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
        //alert(this.FormattedCode);
        this.actorservice.GetIvfCycleEmbryoTransferredController(this.CurrentIvfCycleEmbryoTransferredRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
                    this.CurrentIvfCycleEmbryoTransferredController = this.ApiResData.Result;

                    //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

                    //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
                    //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
                    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

                    //this.stopRefreshing();
                    //   this.LoadGuardian();
                    //this.LoadMessages();


                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }



    AddTests() {
        this.LoadEmbryoTransfer();
        var TransferDate = this.EmbryoTransFerEndInfo.TransferDate;
        const modalRef = this.modalService.open(NgbAddScanTestModal,
            {
                centered: true,
                backdrop: 'static',
                keyboard: false

            })
        modalRef.componentInstance.Typeofscreen = 'Et';
        modalRef.componentInstance.TcModelName = this.ActorDetails.TCModelName;
        modalRef.componentInstance.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, TransferDate)[0].CycleActivityCode;
        //alert(modalRef.componentInstance.ActivityCode);
        modalRef.componentInstance.CycleCode = this.CycleCode;
        modalRef.componentInstance.ActorCode1 = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
        modalRef.componentInstance.TestCode = this.CurrentIvfCycleTestByCodeController[0].TestCode;

        modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
    }
    AddMedicine() {
        this.LoadEmbryoTransfer();
        var TransferDate = this.EmbryoTransFerEndInfo.TransferDate;
        const modalRef = this.modalService.open(NgbAddScanMedicineModal,
            {
                centered: true,
                backdrop: 'static',
                keyboard: false

            })
       
        modalRef.componentInstance.Typeofscreen = 'Et';
        modalRef.componentInstance.TcModelName = this.ActorDetails.TCModelName;
        modalRef.componentInstance.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, TransferDate)[0].CycleActivityCode;
        modalRef.componentInstance.CycleCode = this.CycleCode;
        modalRef.componentInstance.ActorCode1 = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);
        modalRef.componentInstance.MedicineCode = this.CurrentIvfCycleMedicineByCodeController[0].MedicineCode;
        modalRef.componentInstance.ClinicalOrderItem = this.CurrentIvfCycleMedicineByCodeController[0].ClinicalOrderItem;
        modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
    }
    EditTest(l: IvfCycleTestByCodeController) {

        this.CurrentSaveIvfCycleTestDataRequest.ActorCode = l.ActorCode;
        this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.CycleCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = l.ItemCode;
        this.CurrentSaveIvfCycleTestDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
        this.CurrentSaveIvfCycleTestDataRequest.TestCode = l.ItemCode;
        this.CurrentSaveIvfCycleTestDataRequest.TestName = l.TestName;
        this.CurrentSaveIvfCycleTestDataRequest.Remarks = l.Comments;
        this.CurrentSaveIvfCycleTestDataRequest.TestDate = l.TestDate;
        this.CurrentSaveIvfCycleTestDataRequest.TestObservation = 0;
        this.CurrentSaveIvfCycleTestDataRequest.Result = l.Result;
        this.CurrentSaveIvfCycleTestDataRequest.ResultUnits = l.ResultUnits;

        const modalRef = this.modalService.open(NgbEditScanTestModal,
            {
                centered: true,
                backdrop: 'static',
                keyboard: false

            })
        modalRef.componentInstance.CurrentSaveIvfCycleTestDataRequest = this.CurrentSaveIvfCycleTestDataRequest;
        modalRef.result.then(x => { this.GetIvfCycleTestByCodeController() })
        //modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
        //modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.ActorID;
        //modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
    }
    EditMedicine(l: IvfCycleMedicineByCodeController) {
        this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = l.ActorCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = l.CycleActivity;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.CycleCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.StartDate = l.StartDate;
        this.CurrentSaveIvfCycleMedicineDataRequest.EndDate = l.EndDate;
        this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = l.ClinicalOrderItem;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = l.CycleMedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
        this.CurrentSaveIvfCycleMedicineDataRequest.Objective = l.Objective;
        this.CurrentSaveIvfCycleMedicineDataRequest.Dose = l.Dosage;
        this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = l.DurationType;
        this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 20;
        this.CurrentSaveIvfCycleMedicineDataRequest.Form = l.DosageForm;
        this.CurrentSaveIvfCycleMedicineDataRequest.Instructions = l.MedicineInstructions;
        this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = l.MedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.MedicineName = l.MedicineName;
        this.CurrentSaveIvfCycleMedicineDataRequest.RecordStatus = l.RecordStatus;
        this.CurrentSaveIvfCycleMedicineDataRequest.Remarks = l.MedicineInstructions;

        //this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode
        //this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.ActivityCode;

        //this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.ActorCode1;
        //this.CurrentSaveIvfCycleMedicineDataRequest.ClinicalOrderItem = this.ClinicalOrderItem;
        //this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = this.MedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.Duration = l.Duration;
        //this.CurrentSaveIvfCycleMedicineDataRequest.DurationType = "normal";



        const modalRef = this.modalService.open(NgbEditScanMedicineModal,
            {
                centered: true,
                backdrop: 'static',
                keyboard: false

            })
        //modalRef.componentInstance.ActivityCode = this.SelectedpatientDetails.CycleActivity;
        //modalRef.componentInstance.CycleCode = this.SelectedpatientDetails.TreatmentCycle;
        //modalRef.componentInstance.ActorCode = this.SelectedpatientDetails.ActorID;
        //modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
        modalRef.componentInstance.CurrentSaveIvfCycleMedicineDataRequest = this.CurrentSaveIvfCycleMedicineDataRequest;
        modalRef.componentInstance.TcModelName = this.ActorDetails.TCModelName;
        modalRef.result.then(x => { this.GetIvfCycleMedicineByCodeController() })
    }
    //Addactivity() {
    //    const modalRef = this.modalService.open(NgbEditGradingetModal,
    //        {
    //            centered: true

    //        })

    //}
    delTEST(l: any) {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            buttonsStyling: false
        }).then(() => {



            this.DeleteActorIdentitiesTest(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Delete Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    DeleteActorIdentitiesTest(l: any) {
        var item = l as IvfCycleTestByCodeController;



        console.log('..................');
        // this.StartRefreshing();
        this.CurrentSaveIvfCycleTestDataRequest.ConditionalOperator = 30;
        this.CurrentSaveIvfCycleTestDataRequest.TestCode = item.TestCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleTestCode = item.ItemCode;
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
        this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;
        this.CurrentSaveIvfCycleTestDataRequest.CycleCode = this.CycleCode;
        //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);

        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveIvfCycleTestData(this.CurrentSaveIvfCycleTestDataRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
                        //this.ShowList = true;
                        //this.LoadOvaryData();
                        this.LoadTestData();
                        //this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    delMedicine(l: any) {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            buttonsStyling: false
        }).then(() => {



            this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Delete Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    DeleteActorIdentitiesMedicine(l: any) {
        var item2 = l as IvfCycleMedicineByCodeController;

        console.log('..................');
        // this.StartRefreshing();
        this.CurrentSaveIvfCycleMedicineDataRequest.ConditionalOperator = 30;

        this.CurrentSaveIvfCycleMedicineDataRequest.MedicineCode = item2.MedicineCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleMedicineCode = item2.CycleMedicineCode;
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ActivityCode = this.GetCycleActivity(this.ReceipientActorCode, this.TransferDateNew)[0].CycleActivityCode;;
        this.CurrentSaveIvfCycleMedicineDataRequest.CycleCode = this.CycleCode;
        //this.CurrentSaveIvfCycleTestDataRequest.FollicularGrowth = this.SelectedpatientDetails.FollicularGrowthCode;
        //this.CurrentSaveIvfCycleTestDataRequest.ActivityCode = this.SelectedpatientDetails.PatientCode;
        this.CurrentSaveIvfCycleMedicineDataRequest.ActorCode = this.GetActorCode(this.SelectedpatientDetails.EggSourceType);

        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveIvfCycleMedicineData(this.CurrentSaveIvfCycleMedicineDataRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Removed Successfully.....!');
                        //this.ShowList = true;
                        this.LoadMedicineData();

                        //this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }

    GetMaxGrade(l: SingleWellCultureByCycleCodeController): string {
        if (l.Grade6 != null) {
            return l.Grade6
        }
        else if (l.Grade5 != null) {
            return l.Grade5
        }
        else if (l.Grade4 != null) {
            return l.Grade4
        }
        else if (l.Grade3 != null) {
            return l.Grade3
        }
        else if (l.Grade2 != null) {
            return l.Grade2
        }
        else if (l.Grade1 != null) {
            return l.Grade1
        }
        return "";

    }
    GetMaxDOC(l: SingleWellCultureByCycleCodeController): number {
        if (l.DOC1 != null) {
            return l.DOC1
        }
        else if (l.DOC2 != null) {
            return l.DOC2
        }
        else if (l.DOC3 != null) {
            return l.DOC3
        }
        else if (l.DOC4 != null) {
            return l.DOC4
        }
        else if (l.DOC5 != null) {
            return l.DOC5
        }
        else if (l.DOC6 != null) {
            return l.DOC6
        }
        return 0;

    }
   
    onSubmit() {
        this.spinner.show();
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndDate = new Date(this.parserFormatter.format(this.TransferEndDate));
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndTime = this.EmbryoTransFerEndInfo.TransferEndTime;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferDate = new Date(this.parserFormatter.format(this.TransferEndDate));
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferStartTime = new Date(this.parserFormatter.format(this.TransferEndDate));
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.AttemptNo = this.EmbryoTransFerEndInfo.AttemptNo;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Doc = this.EmbryoTransFerEndInfo.Doc;
        
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActualTime = this.FollicularPickupEndInfo.OvumPickupTime;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;

        this.CurrentSaveIvfEmbryoTransferAttemptRequest.ConditionalOperator = 1;
        this.actorservice.SaveIvfEmbryoTransferAttempt(this.CurrentSaveIvfEmbryoTransferAttemptRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {

                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();

                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {


                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );


    }
    onSubmitTeam() {
        this.spinner.show();
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Surgeon = this.EmbryoTransFerEndInfo.Surgeon;
        //this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = this.FollicularPickupEndInfo.SurgeonName;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.AsstSurgeon = this.EmbryoTransFerEndInfo.AsstSurgeon;
       // this.CurrentSaveIvfEmbryoTransferAttemptRequest.AsstSurgeonName = this.EmbryoTransFerEndInfo.AsstSurgeonName;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Anesthesiologist = this.EmbryoTransFerEndInfo.Anesthesiologist;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Embryologist = this.EmbryoTransFerEndInfo.Embryologist;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.AnaesthesiaType = this.EmbryoTransFerEndInfo.AnaesthesiaType;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndDate = new Date(this.parserFormatter.format(this.TransferEndDate));
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndTime = new Date();
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferDate = this.EmbryoTransFerEndInfo.TransferDate;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferStartTime = this.EmbryoTransFerEndInfo.TransferStartTime;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActualTime = this.FollicularPickupEndInfo.OvumPickupTime;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        //this.C
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.AttemptNo = this.EmbryoTransFerEndInfo.AttemptNo;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Doc = this.EmbryoTransFerEndInfo.Doc;

        this.CurrentSaveIvfEmbryoTransferAttemptRequest.ConditionalOperator = 2;
        this.actorservice.SaveIvfEmbryoTransferAttempt(this.CurrentSaveIvfEmbryoTransferAttemptRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {

                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();

                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {


                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );


    }
    onAssignedToActorCodesurgeon(event: any) {

        if (event != null) {
            //    if (this.CurrentSaveCounsellingPlanRequest.BranchCode > 0) {
            this.CurrentSaveIvfEmbryoTransferAttemptRequest.Surgeon = event;
            this.CurrentSaveIvfEmbryoTransferAttemptRequest.SurgeonName = event;
            // console.log('event--_>' + event);
            //   }
        }

    }
    onAssignedToActorCodeAsstSurgeon(event: any) {

        if (event != null) {
            
            this.CurrentSaveIvfEmbryoTransferAttemptRequest.AsstSurgeon = event;
            this.CurrentSaveIvfEmbryoTransferAttemptRequest.AsstSurgeonName = event;
           
        }

    }

    onAssignedToActorCodeAsstSurgeon2(event: any) {

        if (event != null) {
            
            this.CurrentSaveIvfEmbryoTransferAttemptRequest.Embryologist = event;
            this.CurrentSaveIvfEmbryoTransferAttemptRequest.EmbryologistName = event;
           
        }

    }
    onAssignedToActorCodeAnaesthetist(event: any) {

        if (event != null) {
           
            this.CurrentSaveIvfEmbryoTransferAttemptRequest.Anesthesiologist = event;
            this.CurrentSaveIvfEmbryoTransferAttemptRequest.AnesthesiologistName = event;
           
        }

    }
    onSubmitTransferDetails() {
        this.spinner.show();
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.EndometriumThickness = this.EmbryoTransFerEndInfo.EndometriumThickness;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.EndometriumThicknessUnit = this.EmbryoTransFerEndInfo.EndometriumThicknessUnit;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Ultrasound = this.EmbryoTransFerEndInfo.Ultrasound;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferProcess = this.EmbryoTransFerEndInfo.TransferProcess;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.ProcessComments = this.EmbryoTransFerEndInfo.ProcessComments;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Remarks = this.EmbryoTransFerEndInfo.Remarks;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferStage = this.EmbryoTransFerEndInfo.TransferStage;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.CultureMedia = this.EmbryoTransFerEndInfo.CultureMedia;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferMethod = this.EmbryoTransFerEndInfo.TransferMethod;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.CatheterType = this.EmbryoTransFerEndInfo.CatheterType;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Catheter = this.EmbryoTransFerEndInfo.Catheter;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.Speculum = this.EmbryoTransFerEndInfo.Speculum;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Speculum = this.EmbryoTransFerEndInfo.Speculum;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.CervicalCleaning = this.EmbryoTransFerEndInfo.CervicalCleaning;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.HasRetainedEmbryos = this.EmbryoTransFerEndInfo.HasRetainedEmbryos;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.HasFragmentation = this.EmbryoTransFerEndInfo.HasFragmentation;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.CervicalMucus = this.EmbryoTransFerEndInfo.CervicalMucus;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Technique = this.EmbryoTransFerEndInfo.Technique;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.BloodOnCatheter = this.EmbryoTransFerEndInfo.BloodOnCatheter;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.HasRetransfer = this.EmbryoTransFerEndInfo.HasRetransfer;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferType = this.EmbryoTransFerEndInfo.TransferType;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Fragmentation = this.EmbryoTransFerEndInfo.Fragmentation;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.ThawingMedia = this.EmbryoTransFerEndInfo.ThawingMedia;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.AnaesthesiaType=

        this.CurrentSaveIvfEmbryoTransferAttemptRequest.DayofCycle = this.EmbryoTransFerEndInfo.DayofCycle;

        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndDate = new Date(this.parserFormatter.format(this.TransferEndDate));
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndTime = new Date();
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferDate = this.EmbryoTransFerEndInfo.TransferDate;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferStartTime = this.EmbryoTransFerEndInfo.TransferStartTime;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActualTime = this.FollicularPickupEndInfo.OvumPickupTime;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        //this.C
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.AttemptNo = this.EmbryoTransFerEndInfo.AttemptNo;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Doc = this.EmbryoTransFerEndInfo.Doc;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TypeOfTransfer = this.EmbryoTransFerEndInfo.TypeOfTransfer;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.DayOfTransfer = this.EmbryoTransFerEndInfo.DayOfTransfer;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.HasStilette = this.EmbryoTransFerEndInfo.HasStilette;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.HasDilator = this.EmbryoTransFerEndInfo.HasDilator;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.ConditionalOperator = 3;
        this.actorservice.SaveIvfEmbryoTransferAttempt(this.CurrentSaveIvfEmbryoTransferAttemptRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {

                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();

                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {


                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );


    }
    onSubmitNotes() {
        this.spinner.show();
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.Surgeon = this.EmbryoTransFerEndInfo.Surgeon;
        //this.CurrentSaveFollicularPickupsDetailV2Request.SurgeonName = this.FollicularPickupEndInfo.SurgeonName;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.AsstSurgeon = this.EmbryoTransFerEndInfo.AsstSurgeon;
        //this.CurrentSaveFollicularPickupsDetailV2Request.AsstSurgeonName = this.FollicularPickupEndInfo.AsstSurgeonName;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.Anesthesiologist = this.EmbryoTransFerEndInfo.Anesthesiologist;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.Embryologist = this.EmbryoTransFerEndInfo.Embryologist;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.AnaesthesiaType = this.EmbryoTransFerEndInfo.AnaesthesiaType;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndDate = new Date(this.parserFormatter.format(this.TransferEndDate));
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferEndTime = new Date();
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferDate = this.EmbryoTransFerEndInfo.TransferDate;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TransferStartTime = this.EmbryoTransFerEndInfo.TransferStartTime;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActualTime = this.FollicularPickupEndInfo.OvumPickupTime;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.FollicularPickupCode = this.FollicularPickupEndInfo.IvfCycleFolliculePickupCode;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.FollicularPickupEndInfo.TreatmentCycle;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedActorCode = AppData.Instance().UserLoginDetails.ActorCode;
        //this.CurrentSaveIvfEmbryoTransferAttemptRequest.ActivityApprovedEmpCode = AppData.Instance().UserLoginDetails.EmployeeCode;
        //this.C
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Notes = this.EmbryoTransFerEndInfo.Notes;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.AttemptNo = this.EmbryoTransFerEndInfo.AttemptNo;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Doc = this.EmbryoTransFerEndInfo.Doc;

        this.CurrentSaveIvfEmbryoTransferAttemptRequest.ConditionalOperator = 6;
        this.actorservice.SaveIvfEmbryoTransferAttempt(this.CurrentSaveIvfEmbryoTransferAttemptRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {

                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.spinner.hide();

                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");
                        this.spinner.hide();

                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {


                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.spinner.hide();
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.spinner.hide();
                        this.stopRefreshing();
                    }
                }
            );


    }
    
    SaveTransfered(l: SingleWellCultureByCycleCodeController) {



        this.CurrentSaveIvfEmbryoTransferAttemptRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.AttemptNo = this.EmbryoTransFerEndInfo.AttemptNo;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.Doc = this.EmbryoTransFerEndInfo.Doc;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.SingleWellCultureCode = l.SingleWellCultureCode;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.IsTransferred = true;
        this.CurrentSaveIvfEmbryoTransferAttemptRequest.ConditionalOperator = 4;
        this.actorservice.SaveIvfEmbryoTransferAttempt(this.CurrentSaveIvfEmbryoTransferAttemptRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {

                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');

                        this.LoadSingle();
                        this.stopRefreshing();

                    }
                    else {
                        alertFunctions.AlertParam("Invalid Operation...!");


                        this.stopRefreshing();

                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {


                        alert(this.ApiResData.ErrorData);


                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );


    }
    Addactivity() {
        const modalRef = this.modalService.open(NgbEditGradingetModal,
            {
                centered: true,
                size: "lg",
                backdrop: 'static',
                keyboard: false

            })
        modalRef.componentInstance.Cyclenumber = this.CycleCode;

        modalRef.componentInstance.ActorCode = this.ActorDetails.RecepientActorCode;
        modalRef.componentInstance.EggSourceType = this.ActorDetails.EggSourceType;
        modalRef.componentInstance.EggActorCode = this.ActorDetails.EggActorCode;
        modalRef.result.then(x => { this.GetIvfCycleEmbryoTransferredController() })
        // modalRef.componentInstance.model = "Add";
    }
    EmbryoTransfer() {
        swal({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#0CC27E',
            cancelButtonColor: '#FF586B',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonClass: 'btn btn-success btn-raised mr-5',
            cancelButtonClass: 'btn btn-danger btn-raised',
            allowOutsideClick: false,
            buttonsStyling: false
        }).then(() => {

            this.IsTransferCompeted();

            //this.DeleteActorIdentitiesMedicine(l);
            // alertFunctions.AlertParam('Delete Successfully...!');

        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
                swal(
                    'Cancelled',
                    'Saving Operation Cancelled :)',
                    'error'
                )
            }
        })
    }
    IsTransferCompeted() {


        console.log('..................');
        //this.StartRefreshing();
        this.CurrentSaveCycleStatusRequest.ConditionalOperator = 70;

        this.CurrentSaveCycleStatusRequest.TreatmentCycleCode = this.CycleCode;
        this.CurrentSaveCycleStatusRequest.ActivityName = "Embryo Transfer";
        this.CurrentSaveCycleStatusRequest.ActivityStatus = "Completed";
        this.CurrentSaveCycleStatusRequest.Remarks = "None";
        //this.CurrentActorDeleteDocRquest.DocType = "Clincial Record"
        //this.CurrentActorDeleteDocRquest.ActorCode = this.ActorCode;


        //this.CurrentSaveIvfCycleTestDataRequest.ActorCode = this.SelectedpatientDetails.FollicularGrowthCode;
        this.actorservice.SaveCycleStatus(this.CurrentSaveCycleStatusRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    if (this.ApiResData.Result > 0) {
                        //this.clearData2();

                        //alertFunctions.AlertParam('Deleted Successfully.....!');
                        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
                        this.LoadCycles();
                        //this.LoadScansData();
                        //this.LoadOvaryData();
                        //this.LoadTestData();
                        //this.LoadMedicineData();
                        //this.ShowList = true;
                        //this.LoadMedicineData();

                        //this.stopRefreshing();

                    }
                    else {
                        this.stopRefreshing();
                        alertFunctions.AlertParam("Invalid Operation...!");
                    }

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);

                        this.stopRefreshing();
                    }
                }
            );

    }
    
   
    

    
   
   
    BackToPatientdata() {
        this.displayPatientdata = true;
        this.displayscansdata = false;
    }
    BackTodashboard2() {
        //this.Showivf = true;
        //this.Showscan = false;
        this.router.navigate(['healins/ivfworkbench']);
    }
    
    private stopRefreshing() {
        this.loaderService.displayLoader(false);
        this.isRequesting = false;
    }
    private StartRefreshing() {
        this.loaderService.displayLoader(true);
        this.isRequesting = true;
    }

    printtransfer() {
        this.printService.printDocument("embryotransfer",
            {
                TreatmentCycleCodedata: this.CycleCode, Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
                ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
                Surgeon: this.EmbryoTransFerEndInfo.SurgeonName, AsstSurgeon: this.EmbryoTransFerEndInfo.AsstSurgeonName, Embryologist: this.EmbryoTransFerEndInfo.EmbryologistName, Anaesthesiologist: this.EmbryoTransFerEndInfo.AnesthesiologistName, Anaesthesia: this.EmbryoTransFerEndInfo.AnaesthesiaType, PlannedTime: this.EmbryoTransFerEndInfo.TransferStartTime, ActualDate: this.EmbryoTransFerEndInfo.TransferDate, ActualTime: this.EmbryoTransFerEndInfo.TransferEndTime,
                Doc: this.EmbryoTransFerEndInfo.Doc, CultureMedia: this.EmbryoTransFerEndInfo.CultureMedia, Method: this.EmbryoTransFerEndInfo.TransferMethod, CatheterType: this.EmbryoTransFerEndInfo.CatheterType, CatheterUsed: this.EmbryoTransFerEndInfo.Catheter, SpeculumUsed: this.EmbryoTransFerEndInfo.Speculum, CervicalCleaning: this.EmbryoTransFerEndInfo.CervicalCleaning, RetainedEmbryos: this.EmbryoTransFerEndInfo.HasRetainedEmbryos,
                TransferDatenew: this.EmbryoTransFerEndInfo.TransferDate, ActivityCodenew: this.ActivityCodenew, ActorCode: this.ActorCode, Fragmentation: this.EmbryoTransFerEndInfo.Fragmentation, CervicalMucus: this.EmbryoTransFerEndInfo.CervicalMucus, Technique: this.EmbryoTransFerEndInfo.Technique, BloodOnCatheter: this.EmbryoTransFerEndInfo.BloodOnCatheter, Retransfer: this.EmbryoTransFerEndInfo.HasRetransfer, EmbryoTransfer: this.EmbryoTransFerEndInfo.TransferType,
                DSADOC: this.DSADetails.DOC, DSASTIMULATION: this.DSADetails.STIMULATION, DSAANTAG: this.DSADetails.ANTAG,
            }
        );
    }

    printtransferdroplet() {
        this.printService.printDocument("embryotransferdroplet",
            {
                TreatmentCycleCodedata: this.CycleCode, Owner: this.SelectedpatientDetails.OwnerName, Gender: this.SelectedpatientDetails.OwnerGender, Age: this.SelectedpatientDetails.OwnerAgeYears, PatientId: this.SelectedpatientDetails.OwnerFormattedCode, Infertility: this.SelectedpatientDetails.InfertilityType, CycleNo: this.SelectedpatientDetails.CycleNo, CycleType: this.SelectedpatientDetails.CycleType, Protocol: this.SelectedpatientDetails.ProtocolName,
                ProtocolStart: this.SelectedpatientDetails.ProtocolStartDate, ProtocolEnd: this.SelectedpatientDetails.ProtocolEndDate,
                Surgeon: this.EmbryoTransFerEndInfo.SurgeonName, AsstSurgeon: this.EmbryoTransFerEndInfo.AsstSurgeonName, Embryologist: this.EmbryoTransFerEndInfo.EmbryologistName, Anaesthesiologist: this.EmbryoTransFerEndInfo.AnesthesiologistName, Anaesthesia: this.EmbryoTransFerEndInfo.AnaesthesiaType, PlannedTime: this.EmbryoTransFerEndInfo.TransferStartTime, ActualDate: this.EmbryoTransFerEndInfo.TransferDate, ActualTime: this.EmbryoTransFerEndInfo.TransferEndTime,
                Doc: this.EmbryoTransFerEndInfo.Doc, CultureMedia: this.EmbryoTransFerEndInfo.CultureMedia, Method: this.EmbryoTransFerEndInfo.TransferMethod, CatheterType: this.EmbryoTransFerEndInfo.CatheterType, CatheterUsed: this.EmbryoTransFerEndInfo.Catheter, SpeculumUsed: this.EmbryoTransFerEndInfo.Speculum, CervicalCleaning: this.EmbryoTransFerEndInfo.CervicalCleaning, RetainedEmbryos: this.EmbryoTransFerEndInfo.HasRetainedEmbryos,
                TransferDatenew: this.EmbryoTransFerEndInfo.TransferDate, ActivityCodenew: this.ActivityCodenew, ActorCode: this.ActorCode, Fragmentation: this.EmbryoTransFerEndInfo.Fragmentation, CervicalMucus: this.EmbryoTransFerEndInfo.CervicalMucus, Technique: this.EmbryoTransFerEndInfo.Technique, BloodOnCatheter: this.EmbryoTransFerEndInfo.BloodOnCatheter, Retransfer: this.EmbryoTransFerEndInfo.HasRetransfer, EmbryoTransfer: this.EmbryoTransFerEndInfo.TransferType,
                DSADOC: this.DSADetails.DOC, DSASTIMULATION: this.DSADetails.STIMULATION, DSAANTAG: this.DSADetails.ANTAG,
            }
        );
    }



}


